import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// PWA kurulum olayini GLOBAL yakala (kenar menudeki "Uygulamayi Indir" butonu kullanir)
window.__biDeferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); window.__biDeferredPrompt = e; });
window.addEventListener('appinstalled', () => { try { localStorage.setItem('biyz_pwa_installed', '1'); } catch (e) {} window.__biDeferredPrompt = null; });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA Service Worker Kaydı
if ('serviceWorker' in navigator) {
  // Yeni surum devreye girdiginde (service-worker.js icinde skipWaiting+clients.claim zaten otomatik
  // calisiyor) bu sekme "controllerchange" olayini alir -> ACIK KALAN sekmeler de otomatik yenilenir.
  // Boylece kullanici F5 yapmasa bile en son canli surumu gorur. refreshing bayragi sonsuz
  // yenileme dongusunu engeller.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => console.log('SW: kayıtlı', reg.scope))
      .catch(err => console.log('SW: hata', err));
  });
}


